export default {
  /**
   * Đợi
   */
  Waiting: 0,

  /**
   * Thực hiẹn bảo trì dữ liệu
   */
  Maintaining: 1,

  /**
   * Có lỗi xảy ra
   */
  Error: 2,

  /**
   * Hoàn thành bảo trì
   */
  Completed: 3,
};
